module.exports = __webpack_public_path__ + "static/media/popup-horario-fim-de-ano.34ad9a9f.png";